import request from "../utils/request";


export function fetchAllBusiness() {
  return request({
    url: '/businesses',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/business.js